import { GenericError } from '@cian/peperrors/shared';

class ParseQueryError extends GenericError {
    constructor(message) {
        super({ type: 'ParseQueryError', domain: 'http-api', message });
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ParseQueryError);
        }
        else {
            this.stack = new Error().stack;
        }
    }
}

export { ParseQueryError };
//# sourceMappingURL=ParseQueryError.mjs.map
